<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/interest'">Interest</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/hair-type'">Hair Type</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/body-type'">Body Type</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/eye-type'">Eye Type</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/langugae'">Language</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl =='/prefrence'">Prefrence</div>

                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/interest'">Interest</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/hair-type'">Hair Type</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/body-type'">Body Type</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/eye-type'">Eye Type</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/langugae'">Language</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl =='/prefrence'">Prefrence</li>

                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-interest" *ngIf="CurrentUrl =='/interest'">
                            Add Interest
                        </a>
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-hair-type" *ngIf="CurrentUrl =='/hair-type'">
                            Add Hair Type
                        </a>
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-eye-type" *ngIf="CurrentUrl =='/eye-type'">
                            Add Eye Type
                        </a>
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-body-type" *ngIf="CurrentUrl =='/body-type'">
                            Add Body Type
                        </a>
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-langugae" *ngIf="CurrentUrl =='/langugae'">
                            Add Language
                        </a>
                        <a href="javascript:void(0)" class="btn brand-border-btn" routerLink="/add-prefrence" *ngIf="CurrentUrl =='/prefrence'">
                            Add Prefrence
                        </a>
                    </div>
                </div>
            </div>
            <div class="row align-items-end">
                <div class="col-12 col-sm-4 col-lg-3 pb-3 ">
                    <label for="inputState" class="form-label">Search</label>
                    <input type="text" id="inputState" class="form-control" placeholder="Search By Name" [(ngModel)]='searchKey' (keyup)="p=1;getdata(p)">
                </div>
                <div class="col-12 col-sm-4 col-lg-3 pb-3 d-none">
                    <label for="inputState" class="form-label">Status</label>
                    <select id="inputState" class="form-select" [(ngModel)]='statuskey' (change)="p=1;getdata(p)">
                        <option value="Active">Active</option>
                        <option value="In-active">In-Active</option>
                    </select>
                </div>

                <div class="col-12 col-sm-4 col-lg-3 pb-3 pt-sm-4 ">
                    <button type="button" class="btn custom-btn btn-danger px-4" (click)="reset()">Reset</button>
                </div>

                <div class="col-12">
                    <div class="card" >
                        <div class="card-body  table-responsive" >
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Name</th>
                                        <th scope="col" *ngIf="CurrentUrl =='/interest'">Icon</th>
                                        <!-- <th scope="col" >Status</th> -->
                                        <th scope="col">Action </th>                                     
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0" >
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td *ngIf="CurrentUrl=='/interest'">{{item.name}}</td>
                                        <td *ngIf="CurrentUrl=='/hair-type'">{{item.hairType}}</td>
                                        <td *ngIf="CurrentUrl=='/body-type'">{{item.bodyType}}</td>
                                        <td *ngIf="CurrentUrl=='/eye-type'">{{item.eyeType}}</td>
                                        <td *ngIf="CurrentUrl=='/langugae'">{{item.language}}</td>
                                        <td *ngIf="CurrentUrl=='/prefrence'">{{item.preference}}</td>
                                        <td  *ngIf="CurrentUrl =='/interest'"><img [src]="item.icon" style="height: 40px; width:40px;background-color:gray !important"></td>
                                        <!-- <td>
                                            <span class="badge bg-success" *ngIf="item.status =='Active'">{{item.status}}</span>
                                            <span class="badge bg-danger" *ngIf="item.status !='Active'">In-Active</span>
                                        </td> -->
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" title="Edit" class="btn btn-primary text-center me-2" (click)="redirect(item,3)">
                                                    <i class="bx bx-pencil" ></i>
                                                </button> 
                                                <button type="button" title="Delete" class="btn btn-danger text-center me-2" (click)="redirect(item,4)">
                                                    <i class="bx bx-trash" ></i>
                                                </button>                                          
                                            </div>
                                        </td>                                            
                                    </tr>
                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getdata((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

<!-- Cancel Popup Modal -->

<button type="button" class="btn gradient1-btn custom-btn me-3" data-bs-toggle="modal" data-bs-target="#WriteReson" id="text3" class="d-none"> </button>

<div class="modal fade" id="WriteReson" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-body">
                <div class="popup-content-box text-center p-4">
                    <div class="popup-content pt-4">
                        <h5 class="title m-0"> Share your Reason </h5>

                        <div class="custom-form pt-4">
                            <form>
                                <div class="row justify-content-center">
                                    <div class="col-12 pt-3">
                                        <div class="form-group pb-4">
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Reason" [(ngModel)]="reasons" [ngModelOptions]="{standalone: true}"></textarea>
                                            <!-- <label class="text-capitalize" for="FullName"> Reason </label> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="form-btn">
                                    <button class="btn custom-btn gradient1-btn me-5" (click)="delete()"> Submit </button>
                                    <button class="btn custom-btn dark-btn" data-bs-dismiss="modal" data-bs-toggle="modal" id="cclosebtn"> Close </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>